exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FieldSummaryPreview__details__1L070 {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.dmb-web__FieldSummaryPreview__dot__2_EnS {\n  background-color: #656568;\n  border-radius: 50%;\n  height: 5px;\n  margin: 0 5px;\n  width: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"details": "dmb-web__FieldSummaryPreview__details__1L070",
	"dot": "dmb-web__FieldSummaryPreview__dot__2_EnS"
};